import {
  borderRadius,
  SkeletonLoader,
  typographyV2,
} from '@toggle/design-system';
import styled, { css } from 'styled-components';

export const Root = styled.div<{ $read: boolean; $isDropdownOpen: boolean }>`
  display: flex;
  align-items: center;
  padding: 12px 16px;
  width: 100%;
  background: ${({ $read, $isDropdownOpen }) =>
    $isDropdownOpen
      ? 'var(--surface-hover)'
      : $read
      ? 'var(--surface-default)'
      : 'var(--background-soft)'};
  cursor: pointer;

  &:hover {
    background-color: var(--surface-hover);
  }
`;

export const ContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  flex: 1;
  overflow: hidden;
`;

export const Header = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
`;

export const HeaderRight = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const DateSpan = styled.span`
  color: var(--text-soft);
  text-align: right;
  ${typographyV2.bodyXs};
`;

export const HeaderLeft = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  color: var(--text-soft);
  ${typographyV2.bodyXs};
`;

export const Dot = styled.div`
  width: 2px;
  height: 2px;
  ${borderRadius.rFull};
  background-color: var(--icon-soft);
`;

export const BodyWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  width: 100%;
`;

export const LogoWrapper = styled.div`
  position: relative;
  width: 32px;
  height: 32px;
  flex-shrink: 0;
`;

export const TextContent = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  overflow: hidden;
`;

export const PrimaryText = styled.p<{
  $read: boolean;
  $isToastVariant?: boolean;
}>`
  ${typographyV2.bodySm};
  color: ${({ $read }) => ($read ? 'var(--text-soft)' : 'var(--text-default)')};

  ${({ $isToastVariant }) =>
    !$isToastVariant &&
    css`
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    `}
`;

export const StyledLoader = styled(SkeletonLoader).attrs({
  areas: [
    {
      styles: {
        width: '100%',
        height: '60px',
        borderRadius: '8px',
      },
    },
  ],
})``;
